<template>
  <div class="battle">
    <div class="zz-page">
      <div class="page-content-new flex-box-div battle-home">
        <!-- 头部 -->
        <otherHeaderTop headerTitle="盲盒对战" :showBack="true" @back="back" :showBalanceOne="false"></otherHeaderTop>
        <div class="detail-content" style="">
          <!-- <div class="page-content-bg">
            <div class="bg-layer1" style="margin-top: 89px"></div>
            <div class="bg-layer2" style="margin-top: 89px"></div>
          </div> -->
          <div class="abs-full">
            <div class="room-list" v-if="config.bottomType == 0">
              <div class="room-top">
                <div class="bt-tab-view" style="width: 100%;">
                  <div class="tab-bg" style="width: 100%;display: flex;justify-content: center;">
                    <div class="amount-tab">
                      <div @click="changeFilterIndex(-1)" name="-1" :class="[config.filterIndex == -1 ? 'active' : '']"
                        class="tab-item">
                        我的
                      </div>
                      <div @click="changeFilterIndex(0)" name="0" :class="[config.filterIndex == 0 ? 'active' : '']"
                        class="tab-item">
                        全部
                      </div>
                      <div @click="changeFilterIndex(index + 1)" :name="index + 1" :class="[
                        config.filterIndex == index + 1 ? 'active' : '',
                      ]" class="tab-item" v-for="(item, index) in config.battle_filter_items" :key="index">
                        {{ item }}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="state-box" v-if="config.bottomType == 0">
                  <!-- <div class="setting-box"></div> -->
                  <div class="state-tab">
                    <div @click="changeState(1)" :class="[config.state == 1 ? 'active' : '']" class="tab-item">
                      等待中
                    </div>
                    <div @click="changeState(2)" :class="[config.state == 2 ? 'active' : '']" class="tab-item">
                      对战中
                    </div>
                    <!-- <div
                      @click="changeState(3)"
                      :class="[config.state == 3 ? 'active' : '']"
                      class="tab-item"
                    >
                      已结束
                    </div> -->
                  </div>
                  <div class="more-box" @click="openRule"></div>
                </div>
              </div>
              <div class="battle-list" v-if="config.bottomType == 0">
                <div class="refresh-content van-pull-refresh">
                  <div class="van-pull-refresh__track" style="transition-duration: 0ms; height: auto">
                    <div class="item-container">
                      <div role="feed" class="van-list">
                        <div @click="handleJoin(item.id, item.status)" style="display: inline-block"
                          v-for="(item, index) in roomList" :key="index">
                          <div class="room-item-new animate__zoomIn" :class="[
                            item.status == 0 ? 'pk-room-wait' : 'pk-room-run',
                          ]">
                          <div class="ouhuang-img">
                            {{ item.model == 0 ? '欧皇' : '非酋'}}
                          </div>
                            <!-- <img v-if="item.model == 0" src="../../assets/images/ouhuang1.png" class="ouhuang-img"
                              mode="aspectFit" />
                            <img v-else src="../../assets/images/ouhuang.png" class="ouhuang-img" mode="aspectFit" /> -->
                            <!---->
                            <div class="n-header-box flex-center">
                              <div class="header header-d">
                                <div class="tv-state text-ellipsis">
                                  {{ item.ownerName }}
                                </div>
                              </div>
                              <!---->
                            </div>
                            <div class="user user-flex">
                              <div class="user-item pointer" :class="[`item${idx + 1}`]"
                                v-for="(ele, idx) of item.playerNum" :key="idx + generateSixDigit()">
                                <!---->
                                <!-- item.seats[idx].avatar
                                ? item.seats[idx].avatar -->
                                <img v-if="item.seats[idx].avatar != null" :src="`${$getFullPath(item.seats[idx].avatar)}`"
                                  class="user-img border" mode="aspectFit" style="width: 90%;height: 90%;" />
                                <img v-else :src="battleEmpty" class="user-img" mode="aspectFit" />

                                <div class="abs-full avatar-mask"></div>
                                <div class="home-img" v-if="item.seats[idx] &&
                                  item.seats[idx].playerId == item.userId
                                  "></div>
                                <div class="pk-tag">
                                  <!-- v-if="item.player_info[idx] != null && item.player_info[idx].id == item.user_id" -->
                                  <!---->
                                </div>
                              </div>
                            </div>
                            <div class="box-list" :class="[item.boxData.length > 2 ? 'item-4' : '']">
                              <template v-for="(item,index) in expandAllBoxes(item.boxData, item.boxSequence)">
                                <div @click.stop="openBoxDetail(item)" class="box-item" :key="index">
                                  <div class="img-box 111">
                                    <!-- <img
                                      style="width: 40%; z-index: 9; left: 29%"
                                      :src="item.boxImg02 | fullPath"
                                      class="abs-full box-img"
                                      mode="aspectFit"
                                    /> -->
                                    <img :src="`${$getFullPath(item.boxImg01)}`" class="abs-full box-img" mode="aspectFit" />
                                    <img   style="width: 70%;height:auto; z-index: 9; left: 10%;top:30%;" :src="`${$getFullPath(item.boxImg02)}`" class="abs-full box-img" mode="aspectFit" />
                                    <!-- <img :src="item.boxImg01 | fullPath" class="abs-full box-img" mode="aspectFit" /> -->
                                  </div>
                                  <div class="box-price flex-center text-ellipsis">
                                    <img src="../../assets/images/balance2.png" class="coin" mode="aspectFit" />
                                    <span class="price">{{
                                      item.price || 0.0
                                    }}</span>
                                  </div>
                                </div>
                              </template>
                            </div>
                            <div class="btm-info">
                              <div class="tv-count">
                                <div class="pre-ic"></div>
                                <div class="count">
                                  {{ item.roundNumber }}
                                </div>
                              </div>
                              <div class="op-btn flex-center">
                                <img src="../../assets/images/balance2.png" class="coin" mode="aspectFit" />
                                <span class="price">{{
                                  item.boxPriceTotal
                                }}</span>
                                <span v-if="item.status == 0">加入</span>
                                <span v-if="item.status == 1">观战</span>
                                <span v-if="item.status == 2">查看</span>
                                <!---->
                              </div>
                            </div>
                          </div>
                        </div>
                          <div class="team-detail" style="height: 30px;width: 100%;">  </div>
                      </div>
                    </div>
                    <!---->
                  </div>
                  <div v-if="roomList.length == 0">
                    <div class="no-data" style="height: revert">
                      <div class="empty-box-new"></div>
                      <div class="tip-text">暂无对战数据</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="ten-list" v-if="config.bottomType == 1">
              <div class="ten-record">
                <div class="tob-box">
                  <div class="bt-tab-view">
                    <div class="tab-bg">
                      <div class="amount-tab jc-around">
                        <div @click="changeTenBestType(1)" :class="[config.tenBestType == 1 ? 'active' : '']" name="1"
                          class="tab-item">
                          <div class="icon icon-price"></div>
                          最大金额
                        </div>
                        <div @click="changeTenBestType(2)" :class="[config.tenBestType == 2 ? 'active' : '']" name="2"
                          class="tab-item">
                          <div class="icon icon-increase"></div>
                          最大增长
                        </div>
                        <!-- <div
                          @click="changeTenBestType(3)"
                          :class="[config.tenBestType == 3 ? 'active' : '']"
                          name="3"
                          class="tab-item"
                        >
                          <div class="icon icon-luck"></div>
                          最佳欧皇
                        </div> -->
                      </div>
                    </div>
                  </div>
                  <div class="state-box">
                    <!-- <div class="setting-box"></div> -->
                    <div class="state-tab">
                      <div @click="changeStateTab('todayFightResult')" :class="[
                        config.state_tab == 'todayFightResult'
                          ? 'active'
                          : '',
                      ]" class="tab-item">
                        今日
                      </div>
                      <div @click="changeStateTab('yesterdayFightResult')" :class="[
                        config.state_tab == 'yesterdayFightResult'
                          ? 'active'
                          : '',
                      ]" class="tab-item">
                        昨日
                      </div>
                    </div>
                  </div>
                </div>
                <div class="list-box">
                  <div class="refresh-content van-pull-refresh">
                    <div class="van-pull-refresh__track" style="transition-duration: 0ms">
                      <div class="room-item-list">
                        <div class="item-container van-list">
                          <div style="display: inline-block" @click="handleJoin(item.fight.id, 2)" v-for="(item, index) in tenTopFightData[
                              config.state_tab
                              ]" :key="index">
                            <div class="ten-item animate__animated animate__fadeIn"
                              :class="[config.bottomType == 1 ? 'history' : '']">
                              <div class="n-header-box">
                                <div class="header header-d">
                                  <span class="tv-state text-ellipsis">
                                    {{ item.fight.ownerName }}
                                  </span>
                                </div>
                                <div class="time">
                                  {{ item.fight.createTime.slice(5) }}
                                </div>
                              </div>
                              <div class="user user-flex">
                                <div class="user-item" v-for="(itm, idx) in item.fight.seats" :key="idx">
                                  <!-- <img :src="item.avatar" alt=""> -->
                                  <img :src="$getFullPath(itm.avatar)" class="user-img border" mode="aspectFit" />
                                  <!-- <img :src="itm.avatar | fullPath" class="user-img border" mode="aspectFit" /> -->
                                  <div class="abs-full avatar-mask"></div>
                                  <span class="home-img" v-if="itm.isOwner"></span>
                                  <div class="pk-tag"></div>
                                </div>
                              </div>
                              <div class="box-list " >
                                <template v-for="(item2,index) in expandAllBoxes(
                                  item.fight.boxData,
                                  item.fight.boxSequence
                                )">
                                  <div class="box-item "
                                    :key="index">
                                    <div class="img-box 11">
                                      <!-- <img
                                      style="width: 40%; z-index: 9; left: 29%"
                                      :src="box.active_image"
                                      class="abs-full box-img"
                                      mode="aspectFit"
                                    /> -->
                                      <!-- {{item2}} -->
                                      <img :src="`${$getFullPath(item2.boxImg01)}`" class="abs-full box-img" mode="aspectFit" />
                                      <!-- <img :src="item2.boxImg01 | fullPath" class="abs-full box-img" mode="aspectFit" /> -->
                                    </div>
                                    <div class="box-price flex-center text-ellipsis">
                                      <img src="../../assets/images/balance2.png" class="coin" mode="aspectFit" />
                                      <span class="price">{{
                                        item2.price || 0.0
                                      }}</span>
                                    </div>
                                  </div>
                                </template>
                              </div>
                              <div class="btm-info">
                                <span class="abs-base tv-count">
                                  <div class="pre-ic"></div>
                                  <div class="count">
                                    {{ item.fight.roundNumber }}
                                  </div>
                                </span>
                                <div class="op-btn">
                                  <img src="../../assets/images/balance2.png" class="coin" mode="aspectFit" />
                                  <span>
                                    {{
                                      item.fight.boxPriceTotal | formatNumber
                                    }}
                                  </span>
                                  <span class="split"></span>
                                  <span>
                                    {{
                                      item.totalOrnamentsPrice | formatNumber
                                    }}
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div v-if="tenTopFightData[config.state_tab].length == 0" style="width: 100%; margin-top: 30%">
                            <div class="no-data">
                              <div class="empty-box-new"></div>
                              <div class="tip-text">暂无数据</div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="record-list" v-if="config.bottomType == 2">
              <div class="battle-record">
                <div class="tob-box">
                  <div class="bt-tab-view">
                    <div class="tab-bg">
                      <div class="amount-tab">
                        <div @click="changeHistoryFilterIndex(0)" :class="[config.filterIndex == 0 ? 'active' : '']"
                          class="tab-item">
                          全部
                        </div>
                        <!-- <div @click="changeHistoryFilterIndex(index + 1)" :name="index + 1" :class="[
                          config.filterIndex == index + 1 ? 'active' : '',
                        ]" class="tab-item" v-for="(item, index) in config.battle_filter_items" :key="index">
                          {{ item }}
                        </div> -->
                      </div>
                    </div>
                  </div>
                  <div class="tab-box">
                    <div class="state-box">
                      <!-- <div class="setting-box"></div> -->
                      <div class="state-tab">
                        <div @click="changeHistoryType('all')" :class="[
                          config.history_type == 'all' ? 'active' : '',
                        ]" class="tab-item">
                          全服记录
                        </div>
                        <div @click="changeHistoryType('my')" :class="[config.history_type == 'my' ? 'active' : '']"
                          class="tab-item">
                          个人记录
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="list-box" @scroll="scrollEventFn">
                  <div class="refresh-content van-pull-refresh" style="height: 100%">
                    <div class="van-pull-refresh__track" style="transition-duration: 0ms; height: auto">
                      <div class="room-item-list">
                        <div class="item-container">
                          <div role="feed" class="van-list">
                            <div style="display: inline-block" @click="handleJoin(item.id, 2)"
                              v-for="(item, index) in historyLists" :key="index">
                              <div class="room-item-new pk-room-end animate__fadeIn">
                                <div class="n-header-box" style="padding-top:3vw;color: #FCD71F;">
                                  <div class="header header-d">
                                    <span class="tv-state text-ellipsis">
                                      {{ item.home_owner_name }}
                                    </span>
                                  </div>
                                  <div class="time text-ellipsis">
                                    {{ item.createTime.slice(5) }}
                                    <!-- {{
                                      $moment(item.createtime * 1000).format(
                                        "MM-DD HH:mm:ss"
                                      )
                                    }} -->
                                  </div>
                                </div>
                                <div class="user user-flex">
                                  <div v-for="(itm, idx) in item.userDataResult" :key="idx"
                                    class="user-item pointer item1 user-item-d">
                                    <!-- 房主 -->
                                    <img v-if="item.winnerIds.includes(itm.userId)" src="../../assets/images/winner_head.png"
                                      class="win-img" mode="aspectFit" />
                                    <img :src="`${$getFullPath(itm.avatar)}`" class="user-img border" />
                                    <!-- <img :src="itm.avatar | fullPath" class="user-img border" /> -->
                                    <div class="abs-full avatar-mask"></div>
                                    <span class="home-img" v-if="itm.isHouseOwner == 0"></span>
                                    <div class="pk-tag"></div>
                                  </div>
                                </div>
                                <div class="box-list ">
                                  <template v-for="(item,index) in expandAllBoxes(
                                    item.boxDataResult,
                                    item.boxSequence
                                  )">
                                  <!-- {{itm}} -->
                                    <div class="box-item" 
                                      :key="index" @click.stop="openBoxDetail(item)">
                                      <div class="img-box 22">
                                        <img :src="`${$getFullPath(item.boxImg01)}`" class="abs-full box-img" mode="aspectFit" />
                                        <!-- <img :src="item.boxImg01 | fullPath" class="abs-full box-img" mode="aspectFit" /> -->
                                      </div>
                                      <div class="box-price flex-center text-ellipsis">
                                        <img src="../../assets/images/balance2.png" class="coin" mode="aspectFit" />
                                        <span class="price">{{
                                          item.price || 0.0
                                        }}</span>
                                      </div>
                                    </div>
                                  </template>
                                </div>
                                <div class="btm-info">
                                  <span class="tv-count">
                                    <div class="pre-ic"></div>
                                    <div class="count">
                                      {{ item.roundNumber }}
                                    </div>
                                  </span>
                                  <div class="op-btn flex-center jiner">
                                    <!---->
                                    <!---->
                                    <img src="../../assets/images/balance2.png" class="coin" mode="aspectFit" />
                                    <span>
                                      {{ item.boxPriceTotal | formatNumber }}
                                    </span>
                                    <!-- <span class="split"></span> -->
                                    <span>/</span>
                                    <span>
                                      {{
                                        item.totalOrnamentsPrice | formatNumber
                                      }}
                                    </span>
                                  </div>
                                </div>
                              </div>
                              <div class="team-detail"></div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div v-if="historyLists.length == 0" style="width: 100%; margin-top: 30%">
                      <div class="no-data">
                        <div class="empty-box-new"></div>
                        <div class="tip-text">暂无数据</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="nav-box">
          <div class="battle-nav">
           
            <div
              :class="['nav-list', config.bottomType == 1 ? 'nav-select2' : config.bottomType == 2 ? 'nav-select3' : '']">
              <div class="nav-item" @click="changeBottomType(0)" :class="[config.bottomType == 0 ? 'nav-select' : '']">
                <div class="name" >
                  <span>
                    会员
                  </span>
                  <span>
                    对战
                  </span>
                </div>
              </div>
              <div class="nav-item" @click="changeBottomType(1)" :class="[config.bottomType == 1 ? 'nav-select' : '']">
                <div class="name">
                  <span>
                    十佳
                  </span>
                  <span>
                    对战
                  </span>
                </div>
              </div>
              <div class="nav-item" @click="changeBottomType(2)" :class="[config.bottomType == 2 ? 'nav-select' : '']">
                <div class="name">
                  <span>
                    历史
                  </span>
                  <span>
                    记录
                  </span>
                </div>
              </div>
            </div>
            <div class="create-btn skins__btn" @click="goCreate">
              <span>
                创建对战
              </span>
              </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 盲盒详情 -->
    <modalBoxDetail :showModal="showDetail" :info="curBox" @close="showDetail = false"></modalBoxDetail>
  </div>
</template>

<script>
import otherHeaderTop from "@/components/otherHeaderTop.vue";
import modalBoxDetail from "@/components/common/modalBoxDetail.vue";
import {
  getFightList,
  getUserInfo,
  fightOnMyOwn,
  earlierHistory,
  getBoxList,
  tenTopFight,
} from "@/api/index";
import boxDetail from "./boxDetail.vue";
import bsurl from "@/api/basurl.js";
export default {
  components: {
    boxDetail,
    otherHeaderTop,
    modalBoxDetail,
  },
  data() {
    return {
      page: {
        page: 1,
        size: 10,
      },
      earlierHistoryPage: {
        fightId: 0,
        page: 1,
        size: 10,
      },
      obj: {
        status: 0,
        // pageSize: 100,
        // pageNum: 1
      },
      boxList: [],
      roomList: [],
      boxTypelist: [],
      money: 0,
      sss: 1,
      timerV2: null,
      queryParams: {
        pageSize: 100,
        pageNum: 2,
      },
      hearbeat_timer: null,
      befroomlist: [],
      histroyList: [],
      myList: [],
      roomListIsOver: "加载中",
      battleListIsOver: "加载中",
      boxIsOver: "加载中",
      boxPage: {
        page: 1,
        size: 10,
        gameMouldId: 2,
        orderByFie: 2,
      },
      boxDetail: {
        flag: false,
        boxId: "",
      },
      params: {
        pageNum: 1,
        pageSize: 40,
        status: 0,
      },
      defaultHeader: require("../../assets/images/default-header.png"),
      battleEmpty: require("../../assets/pkHome/2.png"),

      battleParams: {
        page: 1,
        size: 20,
        status: [0],
      },
      showDetail: false,
      tenTopFightData: {
        // yesterdayFightResult: [
        //   {
        //     currentRound: null,
        //     winnerIds: [82],
        //     fight: {
        //       id: 2426,
        //       userId: 77,
        //       seats: [
        //         {
        //           code: 0,
        //           avatar: "http://18.234.30.12:8080",
        //           status: 2,
        //           fightId: null,
        //           nickName: "嘿嘿哈",
        //           playerId: 77,
        //           awardTotalPrices: 0,
        //         },
        //         {
        //           code: 3,
        //           avatar:
        //             "https://pic.rmb.bdstatic.com/bjh/events/4500eccf5109e6a01569594a4a224ced.png",
        //           status: 2,
        //           fightId: null,
        //           nickName: "狄富河",
        //           playerId: 120,
        //           awardTotalPrices: 0,
        //         },
        //         {
        //           code: 2,
        //           avatar:
        //             "http://3.92.67.237:8080/profile/upload/2024/07/12/t0106092929d7fcd91f_20240712153640A003.jpg",
        //           status: 2,
        //           fightId: null,
        //           nickName: "祝婉璧",
        //           playerId: 82,
        //           awardTotalPrices: 0,
        //         },
        //         {
        //           code: 1,
        //           avatar:
        //             "https://img.zcool.cn/community/0179e358a53d9aa801219c77c25d56.jpg@1280w_1l_2o_100sh.jpg",
        //           status: 2,
        //           fightId: null,
        //           nickName: "江芝婕",
        //           playerId: 119,
        //           awardTotalPrices: 0,
        //         },
        //       ],
        //       model: "0",
        //       playerNum: 4,
        //       spectatorNum: null,
        //       roundNumber: 1,
        //       winnerIds: [82],
        //       boxData: {
        //         84: {
        //           boxId: 84,
        //           number: 1,
        //           boxImg01:
        //             "/profile/upload/2024/07/14/0b16c0b530923b7f8ae830e207af03bf0862c766_20240714153919A005.png",
        //           boxImg02: "",
        //           ornaments: null,
        //         },
        //       },
        //       boxPriceTotal: 1.0,
        //       status: 2,
        //       createTime: "2024-10-17 23:17:57",
        //       endTime: "2024-10-17 23:18:09",
        //       beginTime: "2024-10-17 23:18:05",
        //       updateTime: null,
        //       remark: null,
        //     },
        //     fightResult: [
        //       {
        //         id: 48488,
        //         userId: 77,
        //         boxId: 84,
        //         boxName: "一步登天",
        //         boxPrice: 1.0,
        //         ornamentId: 1246291219,
        //         marketHashName: null,
        //         ornamentsZbtId: null,
        //         ornamentsYyId: null,
        //         ornamentName: "AUG | 雇佣兵",
        //         ornamentsPrice: 1.03,
        //         imageUrl:
        //           "https://img.zbt.com/e/steam/item/730/QVVHIHwgQ29udHJhY3RvciAoRmllbGQtVGVzdGVkKQ==.png",
        //         ornamentsLevelId: 5,
        //         ornamentLevelImg:
        //           "http://3.92.67.237:8080/profile/upload/2024/07/11/lv_20240711114236A004.png",
        //         status: 0,
        //         createTime: "2024-10-17 23:18:05",
        //         updateTime: "2024-10-17 23:18:05",
        //         source: 2,
        //         fightId: 2426,
        //         fightRoundNumber: 1,
        //         rollId: null,
        //         holderUserId: 82,
        //       },
        //       {
        //         id: 48489,
        //         userId: 120,
        //         boxId: 84,
        //         boxName: "一步登天",
        //         boxPrice: 1.0,
        //         ornamentId: 164619706,
        //         marketHashName: null,
        //         ornamentsZbtId: null,
        //         ornamentsYyId: null,
        //         ornamentName: "M4A4 | 彼岸花",
        //         ornamentsPrice: 104.48,
        //         imageUrl:
        //           "https://img.zbt.com/e/steam/item/730/TTRBNCB8IFNwaWRlciBMaWx5IChGYWN0b3J5IE5ldyk=.png",
        //         ornamentsLevelId: 1,
        //         ornamentLevelImg:
        //           "http://3.92.67.237:8080/profile/upload/2024/07/11/jin_20240711114152A001.png",
        //         status: 0,
        //         createTime: "2024-10-17 23:18:05",
        //         updateTime: "2024-10-17 23:18:05",
        //         source: 2,
        //         fightId: 2426,
        //         fightRoundNumber: 1,
        //         rollId: null,
        //         holderUserId: 82,
        //       },
        //       {
        //         id: 48490,
        //         userId: 82,
        //         boxId: 84,
        //         boxName: "一步登天",
        //         boxPrice: 1.0,
        //         ornamentId: 751087955,
        //         marketHashName: null,
        //         ornamentsZbtId: null,
        //         ornamentsYyId: null,
        //         ornamentName: "光谱 2 号武器箱",
        //         ornamentsPrice: 116666.55,
        //         imageUrl:
        //           "https://img.zbt.com/e/steam/item/730/U3BlY3RydW0gMiBDYXNl.png",
        //         ornamentsLevelId: 2,
        //         ornamentLevelImg:
        //           "http://3.92.67.237:8080/profile/upload/2024/07/11/hong_20240711114210A002.png",
        //         status: 0,
        //         createTime: "2024-10-17 23:18:05",
        //         updateTime: "2024-10-17 23:18:05",
        //         source: 2,
        //         fightId: 2426,
        //         fightRoundNumber: 1,
        //         rollId: null,
        //         holderUserId: 82,
        //       },
        //       {
        //         id: 48491,
        //         userId: 119,
        //         boxId: 84,
        //         boxName: "一步登天",
        //         boxPrice: 1.0,
        //         ornamentId: 1516808306,
        //         marketHashName: null,
        //         ornamentsZbtId: null,
        //         ornamentsYyId: null,
        //         ornamentName: "沙漠之鹰 | 机械工业",
        //         ornamentsPrice: 47.25,
        //         imageUrl:
        //           "https://img.zbt.com/e/steam/item/730/RGVzZXJ0IEVhZ2xlIHwgTWVjaGEgSW5kdXN0cmllcyAoTWluaW1hbCBXZWFyKQ==.png",
        //         ornamentsLevelId: 2,
        //         ornamentLevelImg:
        //           "http://3.92.67.237:8080/profile/upload/2024/07/11/hong_20240711114210A002.png",
        //         status: 0,
        //         createTime: "2024-10-17 23:18:05",
        //         updateTime: "2024-10-17 23:18:05",
        //         source: 2,
        //         fightId: 2426,
        //         fightRoundNumber: 1,
        //         rollId: null,
        //         holderUserId: 82,
        //       },
        //       {
        //         id: 48492,
        //         userId: 77,
        //         boxId: null,
        //         boxName: "",
        //         boxPrice: null,
        //         ornamentId: 697345536,
        //         marketHashName: "841f4f21-2e39-4665-ac0d-8635a83338dc",
        //         ornamentsZbtId: null,
        //         ornamentsYyId: null,
        //         ornamentName: "失败安慰奖",
        //         ornamentsPrice: 0.01,
        //         imageUrl:
        //           "http://3.92.67.237:8080/profile/upload/2024/07/13/a092eabcf62281189120a838bf0d23a8d497efc441c9-Zl0bMC_fw658webp_20240713012959A014.png",
        //         ornamentsLevelId: 1,
        //         ornamentLevelImg: null,
        //         status: 0,
        //         createTime: "2024-10-17 23:18:05",
        //         updateTime: "2024-10-17 23:18:05",
        //         source: 2,
        //         fightId: 2426,
        //         fightRoundNumber: null,
        //         rollId: null,
        //         holderUserId: 77,
        //       },
        //       {
        //         id: 48493,
        //         userId: 120,
        //         boxId: null,
        //         boxName: "",
        //         boxPrice: null,
        //         ornamentId: 697345536,
        //         marketHashName: "841f4f21-2e39-4665-ac0d-8635a83338dc",
        //         ornamentsZbtId: null,
        //         ornamentsYyId: null,
        //         ornamentName: "失败安慰奖",
        //         ornamentsPrice: 0.01,
        //         imageUrl:
        //           "http://3.92.67.237:8080/profile/upload/2024/07/13/a092eabcf62281189120a838bf0d23a8d497efc441c9-Zl0bMC_fw658webp_20240713012959A014.png",
        //         ornamentsLevelId: 1,
        //         ornamentLevelImg: null,
        //         status: 0,
        //         createTime: "2024-10-17 23:18:05",
        //         updateTime: "2024-10-17 23:18:05",
        //         source: 2,
        //         fightId: 2426,
        //         fightRoundNumber: null,
        //         rollId: null,
        //         holderUserId: 120,
        //       },
        //       {
        //         id: 48494,
        //         userId: 119,
        //         boxId: null,
        //         boxName: "",
        //         boxPrice: null,
        //         ornamentId: 697345536,
        //         marketHashName: "841f4f21-2e39-4665-ac0d-8635a83338dc",
        //         ornamentsZbtId: null,
        //         ornamentsYyId: null,
        //         ornamentName: "失败安慰奖",
        //         ornamentsPrice: 0.01,
        //         imageUrl:
        //           "http://3.92.67.237:8080/profile/upload/2024/07/13/a092eabcf62281189120a838bf0d23a8d497efc441c9-Zl0bMC_fw658webp_20240713012959A014.png",
        //         ornamentsLevelId: 1,
        //         ornamentLevelImg: null,
        //         status: 0,
        //         createTime: "2024-10-17 23:18:05",
        //         updateTime: "2024-10-17 23:18:05",
        //         source: 2,
        //         fightId: 2426,
        //         fightRoundNumber: null,
        //         rollId: null,
        //         holderUserId: 119,
        //       },
        //     ],
        //     totalOrnamentsPrice: 233590.38,
        //     fightBoxVOList: [
        //       {
        //         boxId: 84,
        //         number: 1,
        //         boxImg01:
        //           "/profile/upload/2024/07/14/0b16c0b530923b7f8ae830e207af03bf0862c766_20240714153919A005.png",
        //         boxImg02: "",
        //         ornaments: null,
        //       },
        //     ],
        //   },
        // ],
        // todayFightResult: [
        //   {
        //     currentRound: null,
        //     winnerIds: [120],
        //     fight: {
        //       id: 2468,
        //       userId: 77,
        //       seats: [
        //         {
        //           code: 0,
        //           avatar: "http://18.234.30.12:8080",
        //           status: 2,
        //           fightId: null,
        //           nickName: "嘿嘿哈",
        //           playerId: 77,
        //           awardTotalPrices: 0,
        //         },
        //         {
        //           code: 1,
        //           avatar:
        //             "https://pic.rmb.bdstatic.com/bjh/events/4500eccf5109e6a01569594a4a224ced.png",
        //           status: 2,
        //           fightId: null,
        //           nickName: "狄富河",
        //           playerId: 120,
        //           awardTotalPrices: 0,
        //         },
        //       ],
        //       model: "0",
        //       playerNum: 2,
        //       spectatorNum: null,
        //       roundNumber: 1,
        //       winnerIds: [120],
        //       boxData: {
        //         84: {
        //           boxId: 84,
        //           number: 1,
        //           boxImg01:
        //             "/profile/upload/2024/07/14/0b16c0b530923b7f8ae830e207af03bf0862c766_20240714153919A005.png",
        //           boxImg02: "",
        //           ornaments: null,
        //         },
        //       },
        //       boxPriceTotal: 1.0,
        //       status: 2,
        //       createTime: "2024-10-26 21:14:40",
        //       endTime: "2024-10-26 21:15:12",
        //       beginTime: "2024-10-26 21:15:08",
        //       updateTime: null,
        //       remark: null,
        //     },
        //     fightResult: [
        //       {
        //         id: 48734,
        //         userId: 77,
        //         boxId: 84,
        //         boxName: "一步登天",
        //         boxPrice: 1.0,
        //         ornamentId: 1246291219,
        //         marketHashName: null,
        //         ornamentsZbtId: null,
        //         ornamentsYyId: null,
        //         ornamentName: "AUG | 雇佣兵",
        //         ornamentsPrice: 1.02,
        //         imageUrl:
        //           "https://img.zbt.com/e/steam/item/730/QVVHIHwgQ29udHJhY3RvciAoRmllbGQtVGVzdGVkKQ==.png",
        //         ornamentsLevelId: 5,
        //         ornamentLevelImg:
        //           "http://3.92.67.237:8080/profile/upload/2024/07/11/lv_20240711114236A004.png",
        //         status: 0,
        //         createTime: "2024-10-26 21:15:08",
        //         updateTime: "2024-10-26 21:15:08",
        //         source: 2,
        //         fightId: 2468,
        //         fightRoundNumber: 1,
        //         rollId: null,
        //         holderUserId: 120,
        //       },
        //       {
        //         id: 48735,
        //         userId: 120,
        //         boxId: 84,
        //         boxName: "一步登天",
        //         boxPrice: 1.0,
        //         ornamentId: 781157101,
        //         marketHashName: null,
        //         ornamentsZbtId: null,
        //         ornamentsYyId: null,
        //         ornamentName: "M4A4 | 沙漠风暴",
        //         ornamentsPrice: 278.25,
        //         imageUrl:
        //           "https://img.zbt.com/e/steam/item/730/TTRBNCB8IERlc2VydCBTdG9ybSAoRmFjdG9yeSBOZXcp.png",
        //         ornamentsLevelId: 1,
        //         ornamentLevelImg:
        //           "http://3.92.67.237:8080/profile/upload/2024/07/11/jin_20240711114152A001.png",
        //         status: 0,
        //         createTime: "2024-10-26 21:15:08",
        //         updateTime: "2024-10-26 21:15:08",
        //         source: 2,
        //         fightId: 2468,
        //         fightRoundNumber: 1,
        //         rollId: null,
        //         holderUserId: 120,
        //       },
        //       {
        //         id: 48736,
        //         userId: 77,
        //         boxId: null,
        //         boxName: "",
        //         boxPrice: null,
        //         ornamentId: 697345536,
        //         marketHashName: "841f4f21-2e39-4665-ac0d-8635a83338dc",
        //         ornamentsZbtId: null,
        //         ornamentsYyId: null,
        //         ornamentName: "失败安慰奖",
        //         ornamentsPrice: 0.01,
        //         imageUrl:
        //           "http://3.92.67.237:8080/profile/upload/2024/07/13/a092eabcf62281189120a838bf0d23a8d497efc441c9-Zl0bMC_fw658webp_20240713012959A014.png",
        //         ornamentsLevelId: 1,
        //         ornamentLevelImg: null,
        //         status: 0,
        //         createTime: "2024-10-26 21:15:08",
        //         updateTime: "2024-10-26 21:15:08",
        //         source: 2,
        //         fightId: 2468,
        //         fightRoundNumber: null,
        //         rollId: null,
        //         holderUserId: 77,
        //       },
        //     ],
        //     totalOrnamentsPrice: 279.28,
        //     fightBoxVOList: [
        //       {
        //         boxId: 84,
        //         number: 1,
        //         boxImg01:
        //           "/profile/upload/2024/07/14/0b16c0b530923b7f8ae830e207af03bf0862c766_20240714153919A005.png",
        //         boxImg02: "",
        //         ornaments: null,
        //       },
        //     ],
        //   },
        // ],
      },
      fightList: [],
      fightListParams: {
        pageSize: 10,
        pageNum: 1,
        status: 2,
      },
      fightListIsOver: '加载中',
      // fightListParams2: {
      //   pageSize: 10,
      //   pageNum: 1,
      //   status: 1,
      // },
      // 新的
      ruleContent: "",
      showRule: false,
      page: 1,
      lists: [],
      timeout: null,
      config: {
        battle_filter_items: ["0-100", "100-200", "200-500","500+"],
        // battle_filter_items: [],
        state: 1, // 0 等待中 1 对战中 -1 参与中
        filterIndex: 0,
        filterHistoryIndex: 0,
        bottomType: 0,
        tenBestType: 1,
        state_tab: "todayFightResult",
        history_type: "all",
      },

      user: {},
      // bottomType: 0,
      // tenBestType: 1,
      tenBest: [],
      curBoxInfo: {},
      // state_tab: "today",
      historyLists: [],
      historyPage: 1,
      isOver: false,
      // history_type: "all",
      websock: "",
      boxPriceTotalMin: "",
      boxPriceTotalMax: "",
      curBox: {
        boxList: {
          skins_types: [],
          box_skins: [],
        },
      },
    };
  },
  // watch: {
  //   roomList(newValue) {
  //     if (newValue.length != 0) {
  //       this.earlierHistoryPage.fightId = newValue[newValue.length - 1].id;
  //     }
  //   },
  // },
  created() {
    // this.getBox();
    this.getuser();
    this.$soundStop("boxAnimBattle");
  },
  computed: {},
  mounted() {
    // 建立 web socket 连接
    //this.getuser();
    /* this.getList(); */
  },
  beforeDestroy() {
    this.$sockets.close();
    /*  this.$sockets.close(); */
    /*  clearInterval(this.timerV2);
    this.timerV2 = null; */
  },
  methods: {
    generateSixDigit() {
  return Math.floor(Math.random() * 900000) + 100000;
},
    // 下拉刷新
    scrollEventFn(event) {
      // console.log("scrollEventFn", event);
      const container = event.target;
      if (
        container.scrollTop + container.clientHeight >=
        container.scrollHeight
      ) {
        if (this.fightListIsOver == "加载中") {
          this.fightListParams.pageNum++;
          setTimeout(() => {
            this.getFightListFn();
          }, 5);
        } else {
          this.$message({
            duration: 1000,
            message: "暂无更多数据",
            type: "warning",
            customClass: "log_warning",
          });
        }
      }
    },
    // 获取历史记录
    getFightListFn() {
      getFightList(this.fightListParams).then((res) => {
        let lists = [];
        lists = res.data.rows;
        this.historyLists.push(...lists);
        this.historyLists.forEach((item) => {
          item.boxDataResult = JSON.parse(item.boxData);
          item.userDataResult = JSON.parse(item.userData);
        });
        // console.log("lists", this.historyLists);
        if (lists.length < this.fightListParams.pageSize) {
          this.fightListIsOver = "暂无更多";
        }

        // this.list = res.data.data;
      });
      // fightOnMyOwn(this.fightListParams).then((res) => {
      //   console.log("getFightList", res);
      //   // this.list = res.data.data;
      // });
    },
    formatToK(value) {
      if (value >= 1000) {
        return (value / 1000).toFixed(1) + "k";
      } else {
        return value.toString();
      }
    },
    processFightResult(fightResult) {
      fightResult.forEach(({ fight }) => {
        fight.seats.forEach((seat) => {
          const isOwner = seat.playerId === fight.userId;
          seat.isOwner = isOwner;
          if (isOwner) {
            fight.ownerName = seat.nickName;
          }
        });
      });
    },
    getTenTopFight() {
      tenTopFight({ maxType: this.config.tenBestType }).then((res) => {
        if (res.data.code == 200) {
          this.tenTopFightData = res.data.data;
          this.processFightResult(this.tenTopFightData.yesterdayFightResult);
          this.processFightResult(this.tenTopFightData.todayFightResult);
        } else {
          this.$message({
            duration: 1000,
            message: res.data.msg,
            type: "warning",
            customClass: "log_warning",
          });
        }
        // this.list = res.data.data;
      });
    },
    changeFilterIndex(item) {
      this.config.filterIndex = item;
      switch (Number(item)) {
        case -1:
          this.boxPriceTotalMin = "";
          this.boxPriceTotalMax = "";
          break;
        case 0:
          this.boxPriceTotalMin = "";
          this.boxPriceTotalMax = "";
          break;
        case 1:
          this.boxPriceTotalMin = 0;
          this.boxPriceTotalMax = 100;
          break;
        case 2:
          this.boxPriceTotalMin = 100;
          this.boxPriceTotalMax = 200;
          break;
        case 3:
          this.boxPriceTotalMin = 200;
          this.boxPriceTotalMax = 500;
          break;
        case 4:
          this.boxPriceTotalMin = 500;
          this.boxPriceTotalMax = 999999;
          break;
      }
      this.params.pageNum = 1;
      this.changeState(1);
    },
    changeState(index) {
      this.config.state = index;
      this.$sockets.close();
      this.roomList = [];
      if (index == 1) {
        this.params.status = 0;
        if(this.config.filterIndex!=0){
          this.params.boxPriceTotalMin = this.boxPriceTotalMin;
          this.params.boxPriceTotalMax = this.boxPriceTotalMax;
        }else{
          this.params.boxPriceTotalMin = "";
          this.params.boxPriceTotalMax = "";
        }
        this.getuser();
      } else if (index == 2) {
        this.params.status = 1;
        this.getuser();
      } else if (index == 3) {
        this.battleParams.status = [2];
        this.battleParams.page = 1;
        this.getBattleList();
      }
      console.log("测试数据", index, this.obj.status);
      // return
    },
    getLists() { },
    openBoxDetail(item) {
      this.$soundPlay("click");
      this.showDetail = true;
      this.curBox = item;
    },
    changeTenBestType(type) {
      this.tenTopFightData = {};
      this.config.tenBestType = type;
      // this.
      this.getTenTopFight();
    },
    changeStateTab(type) {
      this.config.state_tab = type;
    },
    changeHistoryFilterIndex() { },
    changeHistoryType(type) {
      this.config.history_type = type;
      this.historyLists = []
      this.fightListIsOver = '加载中'
      if (type == "all") {
        this.fightListParams = {
          pageSize: 10,
          pageNum: 1,
          status: 2,
        };
      } else {
        this.fightListParams = {
          pageSize: 10,
          pageNum: 1,
          status: 2,
          userId: this.userId,
        };
      }
      this.getFightListFn();
    },
    changeBottomType(type) {
      // console.log("changeBottomType", type);
      this.$soundPlay("click");
      this.config.bottomType = type;
      if (type == 0) {
        this.getuser();
      }
      if (type == 1) {
        this.config.tenBestType = 1;
        this.getTenTopFight();
        this.$sockets.close();
        // this.changeTenBestType(this.config.tenBestType);
      }
      if (type == 2) {
        this.$sockets.close();
        // this.changeHistoryFilterIndex(this.config.filterIndex);
        this.getFightListFn();
      }
    },
    openRule() { },
    goCreate() {
      this.$router.push({
        name: "creatroom",
      });
    },
    // 旧的
    // 根据number生成相应盒子数量
    getBoxes(item) {
      return Array.from({ length: item.number }, (_, i) => i);
    },
    expandAllBoxes(boxes, boxSequence) {
      // console.log("boxes", boxes,'boxSequence',boxSequence);
      // 如果 boxes 是一个数组或对象，先获取所有箱子对象
      let allBoxes = [];
      if (Array.isArray(boxes)) {
        allBoxes = boxes;
      } else if (typeof boxes === "object" && boxes !== null) {
        allBoxes = Object.values(boxes);
      } else if (
        typeof boxes === "object" &&
        boxes !== null &&
        "boxId" in boxes
      ) {
        allBoxes = [boxes];
      } else {
        console.warn("Invalid input type for expandAllBoxes");
        return [];
      }

      // 将 boxSequence 转换为数组
      const sequenceArray = boxSequence
        ? boxSequence.split(",").map((id) => id.trim())
        : [];

      // 根据 boxSequence 的顺序筛选和排序箱子
      const result = sequenceArray
        .map((boxId) => {
          // 查找与 boxId 匹配的箱子
          return allBoxes.find((box) => box.boxId.toString() === boxId);
        })
        .filter((box) => box !== undefined); // 过滤掉未找到的箱子

      // 返回按顺序排列的箱子
      // console.log("result11111", result);
      return result;
    },
    boxDataArray(item) {
      return Object.values(item);
    },
    back() {
      this.$router.go(-1);
    },
    getBtn(item, name) {
      // if(item.model == 0){
      return require(`../../assets/${name}.png`);
      // }else{
      //   return require(`../../assets/${name}2.png`)

      // }
    },
    boxScroll(e) {
      if (
        e.srcElement.scrollLeft + e.srcElement.clientWidth >=
        e.srcElement.scrollWidth
      ) {
        if (this.boxIsOver == "加载中") {
          this.boxPage.page++;
          setTimeout(() => {
            this.getBox();
          }, 5);
        }
      }
    },
    getList() {
      return;
      getFightList().then((res) => {
        console.log("第一次数据", res);
        let arr = res.data.data;
        arr.map((item) => {
          let obj = JSON.parse(item.boxData);
          let valueList = [];
          for (let i in obj) {
            valueList.push(obj[i]);
          }
          return (item.boxData = valueList);
        });
        this.roomList = arr;
      });
    },
    roomScroll(e) {
      if (
        e.srcElement.scrollTop + e.srcElement.clientHeight >=
        e.srcElement.scrollHeight
      ) {
        if (this.obj.status == 3 && this.battleListIsOver == "加载中") {
          this.page.page++;
          setTimeout(() => {
            this.getMy();
          }, 5);
        } else if (this.obj.status == 0 && this.roomListIsOver == "加载中") {
          setTimeout(() => {
            this.getEarlierHistory();
          }, 5);
        }
      }
    },
    getEarlierHistory() {
      return;
      earlierHistory(this.earlierHistoryPage).then((res) => {
        console.log("更早的房间", res.data.data);
        if (res.data.code == 200) {
          this.roomList.push(...res.data.data);
          if (res.data.data.length < this.earlierHistoryPage.size) {
            this.roomListIsOver = "暂无更多";
          }
        }
      });
    },
    playAudio() {
      this.$store.commit("playAudio");
    },
    handleCheck(id) {
      this.$router.push({
        name: "roomDetail",
        query: {
          id: id,
        },
      });
    },
    getBoxDetail(boxId) {
      console.log(boxId);
      console.log("show_box_detail");
      this.boxDetail.flag = true;
      this.boxDetail.boxId = boxId;
    },
    //观战
    handleAudience(fildid) {
      this.$router.push({
        name: "battleroom",
        query: {
          id: fildid,
          uid: this.userId,
          flag: 1,
        },
      });
    },
    //获取用户信息
    getuser() {
      var that = this;
      getUserInfo().then((res) => {
        if (res.data.code == 200) {
          that.userId = res.data.data.userId;
          that.wssock();
        }
      });
    },
    //websocket连接

    wssock() {
      let query = "";
      if(this.config.filterIndex==-1){
        this.params.createUserId = this.userId
      }else{
        delete this.params.createUserId
      }
      for (const key in this.params) {
        if (this.params[key] !== null && this.params[key] !== "") {
          if (query.length === 0) {
            query += `?${key}=${this.params[key]}`;
          } else {
            query += `&${key}=${this.params[key]}`;
          }
        }
      }
      this.$sockets = new WebSocket(
        bsurl.BASE_API + "/ws/fight/hall/" + this.userId + "? " + query
      );
      this.$sockets.onopen = () => {
        // console.log("WebSocket 连接已打开");
      };
      this.$sockets.onmessage = (event) => {
        // console.log("收到消息：", JSON.parse(event.data));
        let data = JSON.parse(event.data);
        if (data.key) {
          let i = this.roomList.findIndex((item) => {
            if (!data.data.rows) {
              return item.id == data.data[0].id;
            } else {
              return item.id == data.data.rows[0].id;
            }
          });
          if (i == -1) {
            if (!data.data.rows) {
              if (data.data[0].status == 2 || data.data[0].status == 3) {
                return;
              } else {
                if (this.roomList.length < 10) {
                  this.roomList.unshift(...data.data);
                } else {
                  this.roomList.unshift(...data.data);
                  this.roomList.splice(
                    this.roomList.length - data.data.length,
                    data.data.length
                  );
                }
              }
            } else {
              if (
                data.data.rows[0].status == 2 ||
                data.data.rows[0].status == 3
              ) {
                return;
              } else {
                if (this.roomList.length < 10) {
                  this.roomList.unshift(...data.data.rows);
                } else {
                  this.roomList.unshift(...data.data.rows);
                  this.roomList.splice(
                    this.roomList.length - data.data.rows.length,
                    data.data.length
                  );
                }
              }
            }
          } else {
            if (
              data.data.rows[0].status == 2 ||
              data.data.rows[0].status == 3
            ) {
              this.roomList.splice(i, 1);
            } else {
              this.roomList.splice(i, 1, data.data.rows[0]);
            }
          }
          // 增加房主名称
          this.roomList.forEach((item) => {
            item.seats.forEach((item2) => {
              if (item2.playerId == item.userId) {
                item.ownerName = item2.nickName;
              }
            });
          });
          this.$forceUpdate();
        }

        // that.befroomlist = data.data;

        // if (that.befroomlist) {
        //   /*   for(let i=0;i<this.befroomlist.length;i++){
        //   this.befroomlist[i].boxData=JSON.parse(this.befroomlist[i].boxData)
        // } */
        //   this.roomList = [];
        //   that.getRoom();
        // }
      };
      this.$sockets.onclose = () => {
        if (this.$route.path == "/px") {
          this.wssock();
        }
      };
    },
    //房间的类型 欧皇

    //玩法说明
    handleilltate() {
      this.$bus.$emit("is_illustrate", true);
      setTimeout(() => {
        this.$bus.$emit("nr_illustrate", "pk");
      }, 100);
    },
    //加入放进观战，查看等
    handleJoin(fildid, status) {
      this.$router.push({
        name: "battleroom",
        query: {
          id: fildid,
          uid: this.userId,
          currentRound: 0,
          battleStatus: status,
        },
      });
    },
    //状态
    //参与进行结束
    handleChangestatus(res) {
      if (res == 3) {
        this.obj.status = res;
        this.page.page = 1;
        this.myList = [];
        this.getMy();
        this.$sockets.close();
      } else {
        this.obj.status = res;
        this.getuser();
        /*   this.getList(); */
      }
    },
    lotteryTest() {
      // 跳转
      this.$router.push({
        name: "lottery",
        query: {},
      });
    },
    lotterySeatTest() {
      // 跳转
      this.$router.push({
        name: "lotterySeat",
        query: {},
      });
    },
    //获取数据 //我的对战
    getMy() {
      fightOnMyOwn({
        playerId: this.userId,
        page: this.page.page,
        size: this.page.size,
        statusList: [0, 1, 2, 3],
      }).then((res) => {
        let arr = res.data.data;
        arr.map((item) => {
          let obj = JSON.parse(item.boxData);
          let valueList = [];
          for (let i in obj) {
            valueList.push(obj[i]);
          }
          return (item.boxData = valueList);
        });
        this.myList.forEach((item) => {
          item.seats.forEach((item2) => {
            if (item2.playerId == item.userId) {
              item.ownerName = item2.nickName;
            }
          });
        });
        this.myList.push(...arr);
        if (res.data.data.length < this.page.size) {
          this.battleListIsOver = "暂无更多";
        }
      });
    },
    //获取对战数据
    getBattleList() {
      fightOnMyOwn({
        page: this.battleParams.page,
        size: this.battleParams.size,
        statusList: this.battleParams.status,
      }).then((res) => {
        let arr = res.data.data;
        arr.map((item) => {
          let obj = JSON.parse(item.boxData);
          let valueList = [];
          for (let i in obj) {
            valueList.push(obj[i]);
          }
          return (item.boxData = valueList);
        });
        console.log("fightOnMyOwn", arr);
        this.roomList.push(...arr);
        if (arr.length < this.battleParams.size) {
          this.battleListIsOver = "暂无更多";
        }
      });
    },

    //查询对战宝箱列表
    getBox() {
      let data = {
        boxType: 2,
      };
      getBoxList(data).then((res) => {
        if (res.data.code == 200) {
          console.log("箱子列表", res.data.data);
          let boxData = [];
          res.data.data.forEach((item) => {
            /* console.log(...item.boxList) */
            boxData.push(...item.boxList);
          });
          console.log("箱子列表", boxData);
          this.boxList.push(...boxData);
          if (res.data.data.length < this.boxPage.size) {
            this.boxIsOver = "暂无更多";
          }
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
// @import "../../static/header.scss";
@import "../../assets/style/bt_tab.scss";
@import "../../assets/style/room_item.scss";

.jiner {
  color: #fff !important;
  background: url('~@/assets/pkHome/5.png');
  background-size: 100% 100%;
  height: 6.13*4.2px !important;
  line-height: 6.13*4.2px !important;
  display: flex;
  align-items: center;
  padding-top: 0 !important;
  @media only screen and (max-width: 430px){
    height: 6.13vw !important;
    line-height: 6.13vw !important;
  }
  span {
    height: 6.13vw !important;
    line-height: 6.13vw !important;
  }
}

.battle {
  --head-height: 14 * 4.2px;
}

.battle-home {
  // padding-bottom: 26.67 * 4.2px;
}

.battle-home .detail-content {
  height: 100%;
  position: relative;
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
}

.battle-home .room-list {
  position: relative;
  width: 100%;
  height: 100%;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
}

.battle-home .room-list .room-top {
  height: 28 * 4.2px;
}

.battle-home .room-list .state-box {
  position: relative;
  height: 7.33 * 4.2px;
  margin-top: 4 * 4.2px;
  padding: 0 0 0.67 * 4.2px 0;
  display: flex;
  margin-left: 1rem;
    // justify-content: center;
}

.battle-home .room-list .state-box .state-tab {
  float: left;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
}

.battle-home .room-list .state-box .state-tab .tab-item {
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  width: 24.27 * 4.2px;
  height: 7.67 * 4.2px;
  line-height: 4 * 4.2px;
  font-size: 3.33 * 4.2px;
  color: #fff;
  text-align: center;
  padding-top: 1.73 * 4.2px;
  background-size: 100% 100%;
  // background-image: url("../../assets/images/st_tab1.png");
  background-image: url("../../assets/open/2.png");
}

.battle-home .room-list .state-box .state-tab .tab-item.active {
  color: #fff;
  // background-image: url("../../assets/images/st_tab2.png");
  background-image: url("../../assets/open/1.png");
}

// .battle-home .room-list .state-box .state-tab .tab-item:nth-child(1) {
//   // margin-left: 10.13 * 4.2px;
// }

// .battle-home .room-list .state-box .state-tab .tab-item:nth-child(2) {
//   margin-left: 112.386px;
// }

// .battle-home .room-list .state-box .state-tab .tab-item:nth-child(3) {
//   margin-left: 3.33 * 4.2px;
// }

.battle-home .room-list .state-box .more-box {
  position: absolute;
  top: 0px;
  right: 2.53 * 4.2px;
  width: 4.53 * 4.2px;
  height: 4.53 * 4.2px;
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACIAAAAiCAMAAAANmf*4.2pxAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAA2UExURQAAADqbzipNeDxMmE9q0UTI/zFunVBq0U5q0SAgRyQnUyQmU0K98z+y5i5jkSdCbCU2YDaFtbldJJ4AAAAJdFJOUwD///////+Af3Idfc0AAACFSURBVDjLrdRLDoAgDATQFoqi+L3/Za26UCNOjTIrFi+Upg1EFAUkkib6tnlM66MhdiNQqBGSxkh5MlZHXJ704ZQ8Ce/IVgWT6+ELcRqD3K/LknFmZkwYN30mHSbrsydMjEmXIWW2bugCG2RdK/ebvCj0uaOERRKqPTTJ14TNJtSgL0jFAmSRI76Wh6bQAAAAAElFTkSuQmCC) no-repeat center center / 100% 100%;
}

.battle-home .room-list .state-box .more-box .more-options {
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  position: absolute;
  top: 5.33 * 4.2px;
  right: 1px;
  z-index: 10;
  width: 94.67 * 4.2px;
  height: 21.87 * 4.2px;
  background-size: 100% 100%;
  background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAsYAAACkCAMAAACjFRj/AAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAIfUExURQ4eVhEochUvgw8maBQxiRs9qg8jXw4gWf///xElbA8jZBMsfRc1lhxAsh5CuQ4fXBQpdxUzjxk5nRo6ox5FwClPyB5GwA4hXRQpeBc1kRk4nBk6oBo8pxo8pR9Gxh1DvBMufxQwhhMsfBUvgBIqcw8kZxUvhRIqdBElaREocBMtgBUwhRYyixYyjBc0lBg5nBg4mxc1lBo7pxs+rhs9qxY3lxo7pRs+rBxCths9qhw/rxs/tBs/sxxBtx5Evh1BtB1Duh9IyyBJzR9HxiFJyx9GxCJM1RIpdxYzkB1Cuh5Fwg4fWg8jYQ8kZRQrdxQreRg2mREnbRElbhUzkRk5oRk6oxxAtBo8pg8kZhMsehs+rxUvghc1jxYzjhYxihw/sBg4mRYyjhc0kRg3lxxCtRk6oRk6pB5EwBg2lxk4nhk7oh5Fvxk6nxg3mxc0kh5Fwhs+rB1Dux9GxRo+riBHySBKzh1AtiFL0R5Ctx5Cuh5GvylPySBK0B5HySBIzh1DvClQySFK0iBKzytU1yFK0ylQySBM1B5GwixV2B9GxCpT0ytT0yxV2yBIySNN1x5Evh5FwypQyx5HyB5FvitS0SpRyytQzSpSzypRzh9GxStSziJN2CtV3CJO2SJP2yxX3iJO3CRP3i1X4CxX4iNQ4i1Y5ixa6A4eWA8jYhEnbxg3mBs+qhk6oiBIyiFK0SJO2CNP3yRR5P///////zFc6unrnAkAAAC1dFJOU4CLlIeXq4SB94mFkZ6wtYKOm6KnusK7g46bo6Spp8C3kZaQk4yGlI2Ii5KVmJmdoqCeqK2rn6its6yvsbG0ubG2w8a/xL3Njpq2vIKEho+PoIqJm6WmsKeHkK2Tm5qYr6CZnJ+zpqa5oKOluqShnb2st72uwceyybW1u8LIwcW2wsrIzsrDzLvQvs3L0sLOuLzDwbnJxMXIx77F0NTR09fU19nc2t7hgIWKn6qkwsnP1tz67uUZE6kqAAAJrElEQVR42u3W5VJjixaF0QYSaDgktO64QkIIgQTi7sHd3d3d3d3dtd37Ae/+f88D7FM1xyPM+mrVevHnJcB/3J8Xv/8+Pz3c31xuri6sbxyenJ4fH+0tzU68B6CgidmlvaPj89OTw431hdXNy5v7h6fnv79fvHz+9Xh3e7W9PDfv8W3tC8/8uyvE+DsAShonVnb9Z8L9LZ9nfm55++r27vHX88sXL58ef15fBBYnp91T3rV04mBHNOMaYwJQ0phrRrRzQKSveafc05OLgYvrn49PZMYPd9c/AiNDvkGvn3CI0kbtw06rjQFASTarc9g+miZyEH7voG9oJPDj+u6BzPj+9iLw3eMW9hOOPqbJybAMGHvNOjoABenMvcYBC8NpYvY5iH6h2/M9cHF7T2Z8cxUY8XwT9nSImI02i9ZM5ycbBIK3ABQkEBiS+XSz1mJrZIo6eoTfPCOBqxsy48vtxSG3ML3FZbfWGOl8Q3M7r7ON+waAgrhtnbz2ZgOfbqyx2l0t6UL30OL2JZnx5vKkT9jTkmYqLtfxBU08bpemtUEfCUBB+oZWTReX1yTg68qLTWktPULf5PImmfHq3PRgf4fLxNDSk4t46lp9Unc9p/I1AAVVcuq7k/S1al5RMl3LMLk6+gen51bJjBfm3V5CZC/Wfikp5GoiEzmpdQnVNABKqk6oS+UkRmq4hSVftMV2EeF1zy+QGa97p*4.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);
}

.battle-home .room-list .state-box .more-box .more-options .more-item {
  height: 10.67 * 4.2px;
  line-height: 10.67 * 4.2px;
  text-align: left;
  font-size: 3.33 * 4.2px;
  padding-left: 5.73 * 4.2px;
  color: #ecf0f9;
}

.battle-home .room-list .state-box .more-box .more-options .divider {
  height: 0.53 * 4.2px;
  width: 100%;
  background-size: 100% 100%;
  background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAsQAAAAEBAMAAAB7DDQtAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAbUExURTdJkjxQjzxQjzxQjjlMlzlPjjxQjzxQjzxQj99sw6cAAAAIdFJOUxzt9uYbLejvi0T6SQAAADFJREFUOMtjcGDABKxGSlQCygEMIx2wMCQKYgLxDqqBQsGRDsRGg5j2QTxaUNC6oAAA+yqKQ9YivSYAAAAASUVORK5CYII=);
}

.battle-home .room-list .battle-list {
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  // padding: 0.67 * 4.2px 0 0 2.27 * 4.2px;
}

.battle-home .room-list .battle-list .item-container {
  margin: 0 0 2.67 * 4.2px;
}

.battle-home .room-list .battle-list .empty-div {
  min-height: 66.67 * 4.2px;
}

.battle-home .ten-list {
  position: relative;
  width: 100%;
  height: 100%;
}

.battle-home .record-list {
  position: relative;
  width: 100%;
  height: 100%;
}

.battle-home .nav-box {
  position: relative;
  left: 0;
  bottom: 0;
  width: 100%;
  z-index: 99;
}

.battle-nav {
  position: relative;
  height: 25.33 * 4.2px;
  // background-repeat: no-repeat;
  // background-position: bottom center;
  // background-size: 100% 14.53 * 4.2px;
  // background-image: url("../../assets/images/app_ft_2_1.png");
  // height: 25.33vw;
    background: rgba(10, 0, 76, 0.36);
    border-radius: 8px 8px 8px 8px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 10px;
    width: 100%;

  .nav-list {
    // width: 160px;
    // height: 40px;
    display: flex;
    align-items: center;

    .nav-item {
      width: 4rem;
      height: 4rem;
      line-height: 2rem;
      font-family: PangMenZhengDao, PangMenZhengDao;
      font-size: 0.8rem;
      color: #FFFFFF;
      // line-height: 14px;
      display: flex;
      justify-content: center;
      align-items: center;
      background-size: contain !important;
      box-sizing: border-box;

      .name {
        display: flex;
        flex-direction: column;

        span {
          line-height: 16px;
        }
      }
    }
    .nav-item:nth-child(1) {
      background: url('~@/assets/pkHome/b1.png') no-repeat center  center;
    }
    .nav-item:nth-child(2) {
      background: url('~@/assets/pkHome/b2.png') no-repeat center  center;

    }
    .nav-item:nth-child(3) {
      background: url('~@/assets/pkHome/b3.png') no-repeat center  center;
    }
    .nav-item.nav-select:nth-child(1) {
      background: url('~@/assets/pkHome/b1-1.png') no-repeat center  center;
    }
    .nav-item.nav-select:nth-child(2) {
      background: url('~@/assets/pkHome/b2-1.png') no-repeat center  center;

    }
    .nav-item.nav-select:nth-child(3) {
      background: url('~@/assets/pkHome/b3-1.png') no-repeat center  center;
    }
  }

  // .nav-select2 {
  //   background: url('~@/assets/pkHome/12.png') no-repeat;
  //   background-size: 100% 100%;
  // }

  // .nav-select3 {
  //   background: url('~@/assets/pkHome/13.png') no-repeat;
  //   background-size: 100% 100%;
  // }
}

.battle-nav .img-layer2 {
  z-index: 16;
  position: absolute;
  top: -6.13 * 4.2px;
  left: 0;
  right: 0;
  height: 5.47 * 4.2px;
  background-size: 100% 100%;
  background-image: url("../../assets/images/box_bg_7.png");
}

.battle-nav .nav-box {
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  float: left;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  width: 42.13 * 4.2px;
  height: 14.4 * 4.2px;
  margin: 2.13 * 4.2px 0 0 3.73 * 4.2px;
  padding-left: 0.8 * 4.2px;
  background-size: 100% 100%;
  background-image: url("../../assets/images/nav_btn_bg1.png");
}

.battle-nav .nav-box .nav-item {
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  width: 12 * 4.2px;
  height: 12 * 4.2px;
  line-height: 4 * 4.2px;
  padding: 2 * 4.2px;
  text-align: center;
  font-size: 2.67 * 4.2px;
  font-weight: 700;
  color: #8ca6ff;
  margin: 1.47 * 4.2px 0.8 * 4.2px 0;
  background-size: 100% 100%;
  background-image: url("../../assets/images/nav_item_bg1.png");
}

.battle-nav .nav-box .nav-item.active {
  color: #fff;
  background-image: url("../../assets/images/nav_item_bg2.png");
}

.battle-nav .nav-box .nav-item .name {
  margin-top: -0.27 * 4.2px;
}

.battle-nav .create-btn {
  width: 9rem;
  height: 3.2rem;
  text-align: center;
  background-size: 100% 100%;
  background-image: url("~@/assets/image3/home/unpackingBack.png");
  font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
  font-weight: 500;
  font-size: 16px;
  color: #FFFFFF;
  line-height: 3.2rem;
}
.battle-nav .create-btn span{
  background: linear-gradient(90.00000000000156deg, #FFFFFF 0%, #FFAF24 100%); 
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
    color: transparent;
    text-shadow: 0px 0px 7px rgba(0,44,94,0.86);
}

.ten-record {
  position: relative;
  width: 100%;
  height: 100%;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
}

.ten-record .tob-box {
  height: 28 * 4.2px;
}

.ten-record .tob-box .state-box {
  position: relative;
  height: 7.33 * 4.2px;
  margin-top: 4 * 4.2px;
  padding: 0 0 0.67 * 4.2px 0;
}

.ten-record .tob-box .state-box .state-tab {
  float: left;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
}

.ten-record .tob-box .state-box .state-tab .tab-item {
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  width: 24.27 * 4.2px;
  height: 7.67 * 4.2px;
  line-height: 4 * 4.2px;
  font-size: 3.33 * 4.2px;
  color: #fff;
  text-align: center;
  padding-top: 1.73 * 4.2px;
  background-size: 100% 100%;
  background-image: url("../../assets/open/2.png");
}

.ten-record .tob-box .state-box .state-tab .tab-item.active {
  color: #fff;
  background-image: url("../../assets/open/1.png");
}

.ten-record .tob-box .state-box .state-tab .tab-item:nth-child(1) {
  margin-left: 10.13 * 4.2px;
}

.ten-record .tob-box .state-box .state-tab .tab-item:nth-child(2) {
  margin-left: 31.2 * 4.2px;
}

.ten-record .list-box {
  // -webkit-box-flex: 1;
  // -webkit-flex: 1;
  // -ms-flex: 1;
  // flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 0.67 * 4.2px 0 0 1.33 * 4.2px;
}

.ten-record .room-item-list {
  padding: 0.67 * 4.2px 0 0 0px;
}

.ten-record .room-item-list .item-container {
  margin: 0 0 16 * 4.2px;
}

.ten-record .room-item-list .empty-div {
  margin-top: 25vh;
}

.ten-item {
  position: relative;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  width: 45.2 * 4.2px;
  height: 42.13 * 4.2px;
  margin: 0 1.73 * 4.2px 2.4 * 4.2px;
  background-size: 100% 100%;
  background-image: url("../../assets/images/ten_item_bg2.png");
}

.ten-item.history {
  background-image: url("../../assets/images/room_end2.png");
}

.ten-item .user {
  position: relative;
  height: 9.6 * 4.2px;
  margin-top: 1.33 * 4.2px;
}

.ten-item .user .user-item {
  position: relative;
  display: inline-block;
  width: 9.6 * 4.2px;
  height: 9.6 * 4.2px;
  margin: 0 0.93 * 4.2px;
  background-size: 100% 100%;
  background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC4AAAAuCAMAAABgZ9sFAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAE4UExURQAAABwpSx0qTBwpTB0oSxUqVRwoTRsqTBwoTBwpTB0pSyAgQAAAVRwpTBozTRwpTSAqShgkSRwoTR0pTDMzMxwpTRwoSxwpTRwcVR0oTQAAABspTCIiRB0oSxomTRwoTBwpTBwpTB4tSxQnThsqTQAAgBwpTB0oTBspSxwpSxwoTBspTCAwUB0qTRwpTBcuRhwpTBwpTBwqTR0pSyQkSRosTxwpTBsqSxwpTB0qTBwoTBwpTBwpSxwpSxwpTABAQBwqTBwqTBspTB0pSyoqVRwoTRwpTRwqTCQkSRspTRwpTBwpTBwpTBspTB0pTBspTB0nTh0pTBwqTBwqTRspSxwqSxwpTBwoTBspSx0pTRwoTRsoURwpTBwpTBwrRxwoShsoSxsoTBwpTBspTRsqTR0oTRomTRwpTBCmyCYAAABndFJOUwDVYe1zDFqN6dmpCAOvCqMYFZJrBbRS5gmFAZYPmBSrwN4RDYwCwnKVpninEHTcC5Sivn0HHcaf5YaR27CcmgSTgKiOBn7B1w5xna65grvDGnysmbptv6SEqrcTs/QSLWax611WWShy4mizAAABMklEQVRIx+3WV1PCQBDA8RU8wWBCQkRAqqBi772hqKCCgr1X1P3+38CCMgm5S+5m9MEZ/8+/udmn3QMwRrLbh9NDrfVGd3VdP3X5gJVPQmvznSw9jLT2OqiaXCK9Vdr7GQlZxa2eJJHdQK5JKyto17F5fiKjffFug46V0KmJvoYekdG5wPc8O0FEfp/h04hLH/Pf3SBvAYDXR+TPA89uAb4AXSEB3vOrfBlevAK8Hdr++U/wItSeBHgLuNx/lz/cCvAxuA8K8EGA6ytuLcfeV0G6zKvHPxdNeopLH5GvNZY44dB50liS2oGjlohhBWtnDjqpmBa8lrJ/O9x0PhIFG+1XLMdJTYlogGo/Q5+HqYdVrdDf3mKcbXWOoidnmJ+C2f3FyEWkd9NTbz0aXdswfSHeAFnDlNUDCteyAAAAAElFTkSuQmCC);
}

.ten-item .user .user-item .win-img {
  position: absolute;
  top: -1.87 * 4.2px;
  right: -1.87 * 4.2px;
  width: 4.67 * 4.2px;
  height: 4.53 * 4.2px;
}

.ten-item .user .user-item .win-img img {
  width: 100%;
  height: 100%;
}

.ten-item .user .user-item .user-img {
  width: 9.6 * 4.2px;
  height: 9.6 * 4.2px;
}

.ten-item .user .user-item .user-img.border {
  -webkit-border-radius: 4.8 * 4.2px;
  border-radius: 4.8 * 4.2px;
}

.ten-item .user .user-item .avatar-mask {
  width: -webkit-calc(9.6 * 4.2px + 0.4 * 4.2px);
  width: calc(9.6 * 4.2px + 0.4 * 4.2px);
  height: -webkit-calc(9.6 * 4.2px + 0.4 * 4.2px);
  height: calc(9.6 * 4.2px + 0.4 * 4.2px);
  background-size: 100% 100%;
  background-repeat: no-repeat;
  background-image: url("../../assets/images/head_bk.png");
  position: absolute;
  top: -1px;
  left: -1px;
}

.ten-item .user .user-item .home-img {
  position: absolute;
  top: 5.33 * 4.2px;
  left: -0.53 * 4.2px;
  width: 3.87 * 4.2px;
  height: 3.6 * 4.2px;
  background-size: 100% 100%;
  background-image: url(data:image/png;base64,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);
}

.ten-item .user .user-item .pk-tag {
  z-index: 1;
  position: absolute;
  top: -webkit-calc(9.6 * 4.2px - 3.2 * 4.2px);
  top: calc(9.6 * 4.2px - 3.2 * 4.2px);
  left: -1.33 * 4.2px;
  width: 12.67 * 4.2px;
  height: 3.2 * 4.2px;
}

.ten-item .user .user-item .pk-tag .tag {
  width: 100%;
  height: 100%;
  -o-object-fit: scale-down;
  object-fit: scale-down;
}

.ten-item .user-flex {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
}

.ten-item .user-abs .item1 {
  position: absolute;
  margin: 0.67 * 4.2px 0 0 4 * 4.2px;
}

.ten-item .user-abs .item2 {
  position: absolute;
  margin: 7.33 * 4.2px 0 0 0px;
}

.ten-item .user-abs .item3 {
  position: absolute;
  margin: 7.33 * 4.2px 0 0 8 * 4.2px;
}

.ten-item .box-list {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  height: 16 * 4.2px;
  overflow-y: hidden;
  overflow-x: scroll;
  margin: 1.33 * 4.2px 1.07 * 4.2px 0;
  align-items: center;
}

.ten-item .box-list::-webkit-scrollbar {
  width: 0.53 * 4.2px;
  height: 0.53 * 4.2px;
}

.ten-item .box-list::-webkit-scrollbar-thumb {
  -webkit-border-radius: 0.27 * 4.2px;
  border-radius: 0.27 * 4.2px;
  background: rgba(80, 80, 80, 0.2);
}

.ten-item .box-list::-webkit-scrollbar-thumb:hover {
  background: rgba(80, 80, 80, 0.5);
}

.ten-item .box-list::-webkit-scrollbar-track {
  -webkit-border-radius: 0;
  border-radius: 0;
  background: rgba(6, 6, 6, 0);
}

.ten-item .box-list .box-item {
  height: 16 * 4.2px;
  margin: 0 1.07 * 4.2px;
}

.ten-item .box-list .box-item .img-box {
  position: relative;
  width: 14.67 * 4.2px;
  height: 13.2 * 4.2px;
}

.ten-item .box-list .box-item .img-box .box-img {
  -o-object-fit: cover;
  object-fit: cover;
}

.ten-item .box-list .box-item .box-price {
  z-index: 1;
  position: relative;
  width: 13.2 * 4.2px;
  height: 4 * 4.2px;
  line-height: 4 * 4.2px;
  margin-top: -2.67 * 4.2px;
  text-align: center;
  font-size: 2.67 * 4.2px;
  color: #ffdeb4;
  background-size: 100% 100%;
  background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEsAAAAaCAMAAADIQlGKAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAACrUExURRMVLv+qOVI6Mv+aPP+cPC8lMG1IMhMWLhQXLQAAAP+aPP//ABgYLf+qVf+fQP+SSRkZLh0cMBUXLR8cMP+AACQgLywkMBsbLichL2BBM/+dO/+aPTorMUUzMf+bQ043Mv+UQ/vcf/+gOv+fPv+ZZv+bPi0lMFA5Mv+2SVE5MiojMS0lMP+cPf+kN2tHM/+ePP+hO/+cPUUyMf+ZM/+cPf+dO/+YPjkrMf/fgQiKqdEAAAA4dFJOU7MJwyZNusqttABEAbQDCAe1trS2Are5tbjHGj+9vxfCE/0jJQUpucIHwri6Ow7JTB42wAVDDSW8yI8/twAAAIlJREFUOMvt1UkCgjAQRNEoqMSAAcR5QJFBxVnB3P9kcojvjjrAW3VXCdlkwERIqZSAory3nvluSFjRsdqV87FLWN51WW++04Cw0m122RfrCWHpx/NuFq+zA1ijZGWbW5wj1uFjm/6pR1gda9hY3dZqrb9Y5K2SP0T+Ntk5ZBeSHU1uB7lp4Nb+AMTDFR/hmYq9AAAAAElFTkSuQmCC);
}

.ten-item .box-list .box-item .box-price .coin {
  width: 2.4 * 4.2px;
  height: 2.4 * 4.2px;
}

.ten-item .box-list .box-item .box-price .price {
  font-family: "Alimama ShuHeiTi", serif;
}

.ten-item .user-flex {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
}

.ten-item .n-header-box {
  font-size: 2.67 * 4.2px;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: justify;
  -webkit-justify-content: space-between;
  -ms-flex-pack: justify;
  justify-content: space-between;
  padding: 0 2.67 * 4.2px;
}

.ten-item .n-header-box div {
  // margin-top: -0.4 * 4.2px;
}

.ten-item .n-header-box .header {
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

.ten-item .n-header-box .header .tv-state {
  float: left;
  width: 20 * 4.2px;
  font-size: 2.67 * 4.2px;
  text-align: center;
  color: #fff;
}

.ten-item .n-header-box .header .state-icon {
  float: left;
  display: inline-block;
  width: 2.13 * 4.2px;
  height: 2.13 * 4.2px;
  margin: 0.27 * 4.2px 0 0 2.27 * 4.2px;
}

.ten-item .btm-info {
  position: relative;
  height: 9.33 * 4.2px;
  color: #ecf0f9;
}

.ten-item .btm-info .tv-count {
  width: 8 * 4.2px;
  height: 4.53 * 4.2px;
  line-height: 4.53 * 4.2px;
  text-align: center;
  font-size: 2.67 * 4.2px;
  color: #7e81ff;
  margin: 2.67 * 4.2px 0 0 2.13 * 4.2px;
  background-size: 100% 100%;
  background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADwAAAAiAgMAAAB+TlIKAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAMUExURQAAAAAAAAAAAAAAADXpN5YAAAAEdFJOU4BAAERf4djoAAAALUlEQVQoz2NgQAZsB1C4DIwbUPkMOWh8aTQ+GxqfkWEUDC7ggMafgMZfgsoFADYUA3obNFseAAAAAElFTkSuQmCC);
}

.ten-item .btm-info .tv-count .pre-ic {
  float: left;
  width: 2.67 * 4.2px;
  height: 2.13 * 4.2px;
  margin: 1.07 * 4.2px 0 0 0.67 * 4.2px;
  background-size: 100% 100%;
  background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAVCAMAAABrN94UAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAA2UExURdbj/9bj/9Xi/9fk/9bj/9nm/////9bj/9Xj/9Lh/9bj/9bj/9bj/9bj/9fk/9bj/9/v/9bj/9G48eUAAAARdFJOU/fa7xP6FAHsEhHu5O3+JusQGqAijgAAAHhJREFUKM+tkdEOgCAIRaksJU3t/3+22oVGTR/auk/HHQcotFIzK7m9GUfUFvRZSKkt+VciRMpzkMxCEKUujDMvQhA+8IASA4OiimlE03ECORXBQygRXq73LlIRbeWLVDxnOakWI+7pT8rJlLJJm2n+x+9Sf4O9nR+KIxX58MeeGAAAAABJRU5ErkJggg==);
}

.ten-item .btm-info .tv-count .count {
  padding-left: 0.67 * 4.2px;
}

.ten-item .btm-info .op-btn {
  float: right;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: right;
  -webkit-justify-content: right;
  -ms-flex-pack: right;
  justify-content: right;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  width: 34.67 * 4.2px;
  height: 8 * 4.2px;
  line-height: 8 * 4.2px;
  color: #fff;
  font-size: 3.33 * 4.2px;
  margin: 0.93 * 4.2px 2 * 4.2px 0 1.2 * 4.2px;
  font-family: "Alimama ShuHeiTi", serif;
}

.ten-item .btm-info .op-btn .coin {
  width: 4.27 * 4.2px;
  height: 4.27 * 4.2px;
}

.ten-item .btm-info .op-btn .price {
  padding: 0 0.67 * 4.2px;
}

.ten-item .btm-info .op-btn .split {
  display: inline-block;
  width: 2.8 * 4.2px;
  height: 3.6 * 4.2px;
  margin: 0 0.67 * 4.2px;
  background-image: url("../../assets/images/split.png");
  background-size: 100% 100%;
}

.ten-item .create-time {
  position: absolute;
  top: 0;
  left: 0;
  font-size: 2.27 * 4.2px;
  line-height: 2.67 * 4.2px;
  color: #ffd5b0;
}

.ten-item .create-time .text1 {
  margin: 2.4 * 4.2px 0 0 1.2 * 4.2px;
}

.ten-item .create-time .text2 {
  margin: 0.4 * 4.2px 0 0 1.2 * 4.2px;
}

.battle-record {
  position: relative;
  width: 100%;
  height: 100%;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
}

.battle-record .tob-box {
  height: 28 * 4.2px;
}

.battle-record .list-box {
  // -webkit-box-flex: 1;
  // -webkit-flex: 1;
  // -ms-flex: 1;
  // flex: 1;
  height: calc(100vh - 300px);
  overflow-y: auto;
  overflow-x: hidden;
  padding: 0.67 * 4.2px 0 0 2.27 * 4.2px;
}

.battle-record .tab-box {
  height: 7.33 * 4.2px;
}

.battle-record .tab-box .state-box {
  position: relative;
  height: 7.33 * 4.2px;
  margin-top: 4 * 4.2px;
  padding: 0 0 0.67 * 4.2px 0;
  
}

.battle-record .tab-box .state-box .state-tab {
  float: left;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
}

.battle-record .tab-box .state-box .state-tab .tab-item {
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  width: 24.27 * 4.2px;
  height: 6.67 * 4.2px;
  line-height: 4 * 4.2px;
  font-size: 3.33 * 4.2px;
  color: #fff;
  text-align: center;
  padding-top: 1.73 * 4.2px;
  background-size: 100% 100%;
  background-image: url("../../assets/open/2.png");
}

.battle-record .tab-box .state-box .state-tab .tab-item.active {
  color: #fff;
  background-image: url("../../assets/open/1.png");
}

.battle-record .tab-box .state-box .state-tab .tab-item:nth-child(1) {
  margin-left: 10.13 * 4.2px;
}

.battle-record .tab-box .state-box .state-tab .tab-item:nth-child(2) {
  margin-left: 31.2 * 4.2px;
}

.battle-record .room-item-list .item-container {
  margin: 0 0 2.67 * 4.2px;
}

.battle-record .room-item-list .empty-div {
  margin-top: 25vh;
}

.ouhuang-img {
  position: absolute;
  top: 0.4rem;
  right: 0.4rem;
  width: 2rem;
  height: 1rem;
  color: #FCD71F;
  font-size: 0.8rem;
}

.appview {
  height: 100vh;
}

// .room-item-new .user-flex::-webkit-scrollbar {
//   height: 0 !important;
// }
.van-list {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}

@media only screen and (max-width: 430px) {
  .page-content-bg .bg-layer2 {
    margin-top: 19vw !important;
  }

  .page-content-bg .bg-layer1 {
    margin-top: 19.1vw !important;
  }

  .flex-box-div {
    padding-top: 0;
  }

  .battle-home .nav-box {
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
  }

  .battle {
    --head-height: 14vw;
  }

  .battle-home {
    // padding-bottom: 26.67vw;
  }

  .battle-home .room-list .room-top {
    height: 28vw;
  }

  .battle-home .room-list .state-box {
    height: 7.33vw;
    margin-top: 4vw;
    padding: 0 0 0.67vw 0;
   
  }

  .battle-home .room-list .state-box .state-tab .tab-item {
    width: 24.27vw;
    height: 7.67vw;
    line-height: 4vw;
    font-size: 3.33vw;

    padding-top: 1.73vw;
  }

  .battle-home .room-list .state-box .state-tab .tab-item:nth-child(1) {
    // margin-left: 10.13vw;
  }

  .battle-home .room-list .state-box .state-tab .tab-item:nth-child(3) {
    margin-left: 3.33vw;
  }

  .battle-home .room-list .state-box .more-box {
    right: 2.53vw;
    width: 4.53vw;
    height: 4.53vw;
  }

  .battle-home .room-list .state-box .more-box .more-options {
    top: 5.33vw;

    width: 94.67vw;
    height: 21.87vw;
  }

  .battle-home .room-list .state-box .more-box .more-options .more-item {
    height: 10.67vw;
    line-height: 10.67vw;

    font-size: 3.33vw;
    padding-left: 5.73vw;
  }

  .battle-home .room-list .state-box .more-box .more-options .divider {
    height: 0.53vw;
  }

  .battle-home .room-list .battle-list {
    height: 66vh;
    flex: none;
    // padding: 0.67vw 0 0 2.27vw;
  }

  .battle-home .room-list .battle-list .item-container {
    margin: 0 0 2.67vw;
  }

  .battle-home .room-list .battle-list .empty-div {
    min-height: 66.67vw;
  }

  .battle-nav {
    height: 25.33vw;
    background: rgba(10, 0, 76, 0.36);
    border-radius: 8px 8px 8px 8px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 10px;
    width: 100%;

    // background: #12121c url("../../assets/images/app_ft_2_1.png") no-repeat;
    // background-size: 100% 14.53vw;
    // background-position: bottom center;
    .nav-list {

      .nav-item {
        // width: 56px;
        // height: 40px;
        // line-height: 20px;
        // font-family: PangMenZhengDao, PangMenZhengDao;
        // font-size: 14px;
        // color: #FFFFFF;
        // // line-height: 14px;
        // display: flex;
        // justify-content: center;
        // align-items: center;

        .name {
          display: flex;
          flex-direction: column;

          span {
            line-height: 16px;
          }
        }
      }
    }

    // .nav-select2 {
    //   background: url('~@/assets/pkHome/12.png') no-repeat;
    //   background-size: 100% 100%;
    // }

    // .nav-select3 {
    //   background: url('~@/assets/pkHome/13.png') no-repeat;
    //   background-size: 100% 100%;
    // }
  }

  .battle-nav .img-layer2 {
    top: -6.13vw;
    left: 0;
    right: 0;
    height: 5.47vw;
  }

  .battle-nav .nav-box {
    width: 42.13vw;
    height: 14.4vw;
    margin: 2.13vw 0 0 3.73vw;
    padding-left: 0.8vw;
  }

  .battle-nav .nav-box .nav-item {
    width: 12vw;
    height: 12vw;
    line-height: 4vw;
    padding: 2vw;

    font-size: 2.67vw;

    margin: 1.47vw 0.8vw 0;
  }

  .battle-nav .nav-box .nav-item .name {
    margin-top: -0.27vw;
  }


  .ten-record .tob-box {
    height: 28vw;
  }

  .ten-record .tob-box .state-box {
    position: relative;
    height: 7.33vw;
    margin-top: 4vw;
    padding: 0 0 0.67vw 0;
    
  }

  .ten-record .tob-box .state-box .state-tab .tab-item {
    width: 24.27vw;
    height: 6.67vw;
    line-height: 4vw;
    font-size: 3.33vw;

    padding-top: 1.73vw;
  }

  .ten-record .tob-box .state-box .state-tab .tab-item:nth-child(1) {
    margin-left: 10.13vw;
  }

  .ten-record .tob-box .state-box .state-tab .tab-item:nth-child(2) {
    margin-left: 31.2vw;
  }

  .ten-record .list-box {
    padding: 0.67vw 0 0 1.33vw;
    height: calc(100vh - 72vw);
  }

  .ten-record .room-item-list {
    padding: 0.67vw 0 0 0px;
  }

  .ten-record .room-item-list .item-container {
    margin: 0 0 16vw;
    padding-bottom: 10vw;
  }

  .ten-record .room-item-list .empty-div {
    margin-top: 25vh;
  }

  .ten-item {
    width: 45.2vw;
    height: 42.13vw;
    margin: 0 1.73vw 2.4vw;
  }

  .ten-item .user {
    position: relative;
    height: 9.6vw;
    margin-top: 1.33vw;
  }

  .ten-item .user .user-item {
    width: 9.6vw;
    height: 9.6vw;
    margin: 0 0.93vw;
  }

  .ten-item .user .user-item .win-img {
    top: -1.87vw;
    right: -1.87vw;
    width: 4.67vw;
    height: 4.53vw;
  }

  .ten-item .user .user-item .user-img {
    width: 9.6vw;
    height: 9.6vw;
  }

  .ten-item .user .user-item .user-img.border {
    -webkit-border-radius: 4.8vw;
    border-radius: 4.8vw;
  }

  .ten-item .user .user-item .avatar-mask {
    width: -webkit-calc(9.6vw + 0.4vw);
    width: calc(9.6vw + 0.4vw);
    height: -webkit-calc(9.6vw + 0.4vw);
    height: calc(9.6vw + 0.4vw);
  }

  .ten-item .user .user-item .home-img {
    top: 5.33vw;
    left: -0.53vw;
    width: 3.87vw;
    height: 3.6vw;
  }

  .ten-item .user .user-item .pk-tag {
    top: -webkit-calc(9.6vw - 3.2vw);
    top: calc(9.6vw - 3.2vw);
    left: -1.33vw;
    width: 12.67vw;
    height: 3.2vw;
  }

  .ten-item .user-abs .item1 {
    margin: 0.67vw 0 0 4vw;
  }

  .ten-item .user-abs .item2 {
    margin: 7.33vw 0 0 0px;
  }

  .ten-item .user-abs .item3 {
    margin: 7.33vw 0 0 8vw;
  }

  .ten-item .box-list {
    height: 16vw;

    margin: 1.33vw 1.07vw 0;
  }

  .ten-item .box-list::-webkit-scrollbar {
    width: 0.53vw;
    height: 0.53vw;
  }

  .ten-item .box-list::-webkit-scrollbar-thumb {
    -webkit-border-radius: 0.27vw;
    border-radius: 0.27vw;
  }

  .ten-item .box-list .box-item {
    height: 16vw;
    margin: 0 1.07vw;
  }

  .ten-item .box-list .box-item .img-box {
    width: 14.67vw;
    height: 13.2vw;
  }

  .ten-item .box-list .box-item .box-price {
    width: 13.2vw;
    height: 4vw;
    line-height: 4vw;
    margin-top: -2.67vw;

    font-size: 2.67vw;
  }

  .ten-item .box-list .box-item .box-price .coin {
    width: 2.4vw;
    height: 2.4vw;
  }

  .ten-item .n-header-box {
    font-size: 2.67vw;

    padding: 0 2.67vw;
    
  }

  .ten-item .n-header-box div {
    // margin-top: -0.4vw;
  }

  .ten-item .n-header-box .header .tv-state {
    width: 20vw;
    font-size: 2.67vw;
  }

  .ten-item .n-header-box .header .state-icon {
    width: 2.13vw;
    height: 2.13vw;
    margin: 0.27vw 0 0 2.27vw;
  }

  .ten-item .btm-info {
    height: 9.33vw;
  }

  .ten-item .btm-info .tv-count {
    width: 8vw;
    height: 4.53vw;
    line-height: 4.53vw;
    text-align: center;
    font-size: 2.67vw;
    color: #7e81ff;
    margin: 2.67vw 0 0 2.13vw;
  }

  .ten-item .btm-info .tv-count .pre-ic {
    width: 2.67vw;
    height: 2.13vw;
    margin: 1.07vw 0 0 0.67vw;
  }

  .ten-item .btm-info .tv-count .count {
    padding-left: 0.67vw;
  }

  .ten-item .btm-info .op-btn {
    width: 34.67vw;
    height: 8vw;
    line-height: 8vw;

    font-size: 3.33vw;
    margin: 0.93vw 2vw 0 1.2vw;
  }

  .ten-item .btm-info .op-btn .coin {
    width: 4.27vw;
    height: 4.27vw;
  }

  .ten-item .btm-info .op-btn .price {
    padding: 0 0.67vw;
  }

  .ten-item .btm-info .op-btn .split {
    width: 2.8vw;
    height: 3.6vw;
    margin: 0 0.67vw;
  }

  .ten-item .create-time {
    font-size: 2.27vw;
    line-height: 2.67vw;
  }

  .ten-item .create-time .text1 {
    margin: 2.4vw 0 0 1.2vw;
  }

  .ten-item .create-time .text2 {
    margin: 0.4vw 0 0 1.2vw;
  }

  .battle-record .tob-box {
    height: 28vw;
  }

  .battle-record .list-box {
    height: calc(100vh - 72vw);
    padding: 0.67vw 0 0 2.27vw;
  }

  .battle-record .tab-box {
    height: 7.33vw;
  }

  .battle-record .tab-box .state-box {
    height: 7.33vw;
    margin-top: 4vw;
    padding: 0 0 0.67vw 0;
  }

  .battle-record .tab-box .state-box .state-tab .tab-item {
    width: 24.27vw;
    height: 6.67vw;
    line-height: 4vw;
    font-size: 3.33vw;

    padding-top: 1.73vw;
  }

  // .battle-record .tab-box .state-box .state-tab .tab-item:nth-child(1) {
  //   margin-left: 10.13vw;
  // }

  // .battle-record .tab-box .state-box .state-tab .tab-item:nth-child(2) {
  //   margin-left: 31.2vw;
  // }

  .battle-record .room-item-list .item-container {
    margin: 0 0 2.67vw;
  }

  .battle-record .room-item-list .empty-div {
    margin-top: 25vh;
  }

  // .ouhuang-img {
  //   height: 10vw;
  //   width: 10vw;
  // }
}
.room-item-new.pk-room-end .btm-info{
  margin-top: 0.6rem;
}
</style>
